export const config = {
  BASE_URL: import.meta.env.VITE_API_URL,
  INGESTION_BASE_URL: import.meta.env.VITE_INGESTION_URL,
  INGESTION_API_KEY: import.meta.env.VITE_INGESTION_API_KEY,
  // Copilot service (ai-pacs-copilot): WS for chat/effects, REST for history.
  COPILOT_WS_URL: import.meta.env.VITE_COPILOT_WS_URL,
  COPILOT_API_URL: import.meta.env.VITE_COPILOT_API_URL,
};
